import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../services/apiServices/security/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {FoldDetailService} from '../../services/apiServices/business/fold-detail.service';
import {JwtHelperService} from '@auth0/angular-jwt';
import {HttpService} from '../../services/apiServices/http-service.service';
import {FileSaverService} from 'ngx-filesaver';
import {CommonService} from '../../services/apiServices/business/common.service';


/**
 * Component that handle the creation of a new password (not change!)
 * it use the create-password component to handle the creation
 */
@Component({
  selector: 'app-download-deposit',
  templateUrl: './download-deposit.component.html',
  styleUrls: ['./download-deposit.component.scss']
})
export class DownloadDepositComponent implements OnInit {

  /**
   * the new password
   */
  public newPassword: string;

  /**
   * the 2nd entry for the new password (they should match)
   */
  public verifyPassword: string;

  /**
   * if the new password is valid regarding security policy
   */
  public isNewPasswordValid: boolean;
  /**
   * if the new password is valid regarding security policy
   */
  public isNewPasswordConfirmValid: boolean;

  /**
   * if the creation of the new password fail
   */
  public createNewPasswordFail: boolean;

  /**
   * the token temporary gave by the back-office
   */
  private temporaryToken: string;

  /**
   * the errorMessage (if the back-office gave one)
   */
  public errorMessage: string;

  /**
   * Message display when the new password is ok
   */
  public archiveNotFoundMsg: string;
  jwtHelper: JwtHelperService;
  fileName: string;
  /**
   * Title of the message, display when the new password is ok
   */
  public successTitle: string;

  constructor(private route: ActivatedRoute, private router: Router,
              private  authenticationService: AuthenticationService,
              private fileSaverService: FileSaverService,
              private  foldDetailService: FoldDetailService,
              private commonService: CommonService,
              private httpService: HttpService,
              private translate: TranslateService) {
    this.jwtHelper = new JwtHelperService();
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
      this.successTitle = title;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.VISU_DOCUMENT_ARCH_NOT_FOUND').subscribe(message => {
      this.archiveNotFoundMsg = message;
    });
  }

  /**
   * handleChangeOfSelectFold queryParams, logging out and subscriptions to errorMessage (from passwordService)
   */
  public ngOnInit(): void {
    this.isNewPasswordValid = false;
    this.isNewPasswordConfirmValid = false;
    this.temporaryToken = this.route.snapshot.queryParams['t'] || '/';
    const decodedToken = this.jwtHelper.decodeToken(this.temporaryToken);
    this.fileName = decodedToken.fileName;
    // this.authenticationService.logout();
    this.httpService.get('../assets/messageOfTheDay.json' ).subscribe( ( response: any ) => {
      (this.translate.getLangs());
        this.translate.set('MOTD_CONTENT', response.MOTD_CONTENT_FR, 'fr');
        this.translate.set('MOTD_CONTENT', response.MOTD_CONTENT_EN, 'en');
    });

    this.getTradForComponent();
  }

  public download() {
  this.foldDetailService.getMailCourrierFiles(this.temporaryToken).subscribe(response => {
      const typeOfReponse = response.headers.get('content-type');
    if (typeOfReponse && !typeOfReponse.includes('application/json')) {
      if (response.body.size > 0) {
        const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
        this.fileSaverService.save(blob);
      }
      else {
        this.commonService.addToast({life: 3000,
          severity: 'error',
          summary: 'Téléchargement',
          detail: this.archiveNotFoundMsg
        });
      }
    }
    }
  );
  }
}
